(function () {
  var WA_TEXT = 'Hello HealthSpot, I would like to send my prescription. I am attaching a photo of the prescription.';
  var RX_NOTE = '<b>Prescription-only item.</b> Prescription medicines are ordered on WhatsApp (0748 173 823) with a photo of your prescription, and paid only after our pharmacist approves it.';
  /* Delivery promise: must match Settings > Shipping (General profile, Kenya zone) */
  var DELIV = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg><span><b>Free delivery across Kenya on orders over KSh 3,000.</b> Nairobi express within 90 minutes for orders placed Mon–Sat, 8am–6pm (KSh 400). Standard KSh 400: Nairobi and major towns 24–36 hours, other towns 2–3 working days.</span>';
  function cards(root) {
    root.querySelectorAll('.hs-qa .quick-add__submit span').forEach(function (s) {
      if (s.children.length || s.textContent.trim() !== 'Shop') return;
      var hint = s.nextElementSibling;
      s.textContent = hint && /visually-hidden/.test(hint.className) ? 'Choose size' : 'Add to cart';
    });
    /* Prescription-only cards: the product-page link becomes the green Buy button */
    root.querySelectorAll('.hs-qa--rx > .hs-qa__view:not([data-hs-buy])').forEach(function (a) {
      a.setAttribute('data-hs-buy', '');
      var n = a.firstChild;
      if (n && n.nodeType === 3) n.textContent = 'Buy';
    });
  }
  /* Product page: delivery promise under the price */
  function deliv() {
    if (!/^\/products\//.test(location.pathname) || document.querySelector('.hs-deliv')) return;
    var form = document.querySelector('main form.main-atc-form');
    if (!form) return;
    var info = form.closest('.product__info-container') || document.querySelector('main');
    var tax = null;
    info.querySelectorAll('div, p, small, span').forEach(function (el) {
      if (!tax && el.children.length < 3 && /calculated at checkout/i.test(el.textContent) && el.textContent.length < 120) tax = el;
    });
    var box = document.createElement('div');
    box.className = 'hs-deliv';
    box.innerHTML = DELIV;
    if (document.querySelector('.hs-rx-pdp')) box.querySelector('span').insertAdjacentHTML('beforeend', ' Prescription items leave after pharmacist approval.');
    if (tax) tax.parentNode.insertBefore(box, tax.nextSibling);
    else form.parentNode.insertBefore(box, form);
  }
  /* Header "Prescription" button opens the WhatsApp-photo prescription modal (free option) instead of the call-back form. */
  function rxHeader(root) {
    if (!document.getElementById('hs-rxm')) return;
    root.querySelectorAll('a.hs-rxbtn:not([data-hs-rx-open])').forEach(function (a) {
      a.setAttribute('data-hs-rx-open', '');
      a.setAttribute('data-hs-rx-title', 'Your prescription medicine');
      a.setAttribute('data-hs-rx-generic', '');
    });
  }
  /* Cart page only: notice above the Checkout button when a prescription-only item is in the cart */
  function cartNote() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    var co = document.getElementById('checkout');
    if (!co) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      return Promise.all(c.items.map(function (i) {
        return fetch('/products/' + i.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          return !!(p && p.tags && (p.tags.indexOf('prescription-only') > -1 || p.tags.indexOf('rx-only') > -1));
        }).catch(function () { return false; });
      }));
    }).then(function (flags) {
      var has = flags.some(Boolean), n = document.querySelector('.hs-cart-rx');
      co = document.getElementById('checkout');
      if (has && !n && co) { n = document.createElement('p'); n.className = 'hs-cart-rx'; n.innerHTML = RX_NOTE; co.parentNode.insertBefore(n, co); }
      if (!has && n) n.remove();
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-hs-rx-generic]');
    if (!o) return;
    var m = document.getElementById('hs-rxm');
    if (!m) return;
    var wa = m.querySelector('[data-hs-rx-wa]');
    if (wa) wa.href = wa.href.split('?')[0] + '?text=' + encodeURIComponent(WA_TEXT);
    var f = m.querySelector('[data-hs-rx-form]');
    if (f) f.href = '/pages/consultations?service=prescription-review#book';
  });
  function run(root) { try { cards(root); } catch (e) {} try { rxHeader(root); } catch (e) {} }
  run(document);
  try { deliv(); } catch (e) {}
  try { cartNote(); } catch (e) {}
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('cart-items')) setTimeout(cartNote, 1500); });
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { run(document); }, 150); })
    .observe(document.body, { childList: true, subtree: true });
})();
